
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personality_test",
      function () {
        return require("private-next-pages/personality_test/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personality_test"])
      });
    }
  